import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import ResultsByGenre from "./ResultsByGenre";
import CircularProgress from "@mui/material/CircularProgress";

const key = "b55d580200c51623fe9608f8f064a09b";

const GenrePage = () => {
  const params = useParams();

  const [genres, setGenres] = useState("");
  const [genreToShow, setGenreToShow] = useState("");

  const getGenres = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/genre/movie/list?api_key=${key}&language=en-US`
    );
    setGenres(response.data.genres);
    setGenreToShow(
      () =>
        response.data.genres.filter(
          (genre) => genre.id === parseInt(params.id)
        )[0]
    );
  };
  useEffect(() => {
    getGenres();
  }, []);

  useEffect(() => {
    if (genres !== "") {
      setGenreToShow(
        () => genres.filter((genre) => genre.id === parseInt(params.id))[0]
      );
    }
    window.scrollTo(0, 0);
  }, [params.id]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="pt-4 " style={{ minHeight: "90vh" }}>
        <div
          className="text-start ms-3 mb-1 text-muted"
          style={{
            color: "rgb(187, 187, 187)",
            fontWeight: "500",
            fontSize: "18px",
            paddingTop: "40px",
          }}
        >
          Search movies by Genre:
        </div>
        <button
          type="button"
          className="genresBtn ms-3 rounded mt-2 py-1 px-3 d-flex align-items-center justify-content-center"
          onClick={handleShow}
        >
          <i className="fa-solid fa-bars me-2"></i>
          All Genres
        </button>

        {genreToShow ? (
          <>
            <div className="d-flex align-items-baseline">
              <h2 className="genreTitle text-start pt-5 ms-3 mb-0">
                {genreToShow.name}
              </h2>
              <i
                className="ms-2 fa-solid fa-play fa-lg"
                style={{ color: "#ee121d" }}
              ></i>
            </div>

            <hr className="text-muted mx-3" />

            <ResultsByGenre genreId={genreToShow.id} />
          </>
        ) : (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ width: "100%", height: "78vh" }}
          >
            <CircularProgress color="secondary" />
          </div>
        )}
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        className="genrePage__offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="text-white ms-2 d-flex align-items-baseline">
            All Genres
            <i
              className="ms-2 fa-solid fa-play fa-xs"
              style={{ color: "#ee121d" }}
            ></i>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="genrePage__list">
            {genres &&
              genres.map((genre) => (
                <Link
                  key={genre.id}
                  to={`/genre/${genre.id}`}
                  style={{ textDecoration: "none" }}
                  className="genrePage__listItem__Link text-white "
                  onClick={handleClose}
                >
                  <li
                    className={
                      genre.id === genreToShow.id
                        ? "genrePage__listItem py-2 px-2 genrePage__listItem_onFocus"
                        : "genrePage__listItem py-2 px-2 "
                    }
                  >
                    {genre.name}
                  </li>
                </Link>
              ))}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default GenrePage;
